$(".events-zoom__link-copy").on("click", function (e) {
	var linkCopyElement = $(this);
	var $tmp = $("<textarea>");
	$("body").append($tmp);
	$tmp.val($(linkCopyElement).attr("data-link")).select();
	document.execCommand("copy");
	$tmp.remove();

	$(linkCopyElement).addClass("active");
	function hideActive(){
		$(linkCopyElement).removeClass("active");
	};
	setTimeout(hideActive, 1000);
});